import CreateLocationModal from './CreateLocationModal';

export default CreateLocationModal;
